import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { FailedSolutions } from './components/FailedSolutions';
import { ProductIntro } from './components/ProductIntro';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { ExpectedResults } from './components/ExpectedResults';
import { FAQ } from './components/FAQ';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const f = window as any;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', '1262815555734160');
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <ProductIntro data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <ExpectedResults data-id="element-7" />
      <FAQ data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}